<template>
  <NdsDropdown :placement="NdsPopoverPlacement.BOTTOM_END">
    <template #trigger>
      <NdsButton
        :color="NdsButtonColor.TRANSPARENT"
        :size="NdsButtonSize.S"
      >
        <span v-if="store.getters.lang === 'en'">English</span>
        <span v-if="store.getters.lang === 'fr'">Français</span>
      </NdsButton>
    </template>

    <template #dropdownContent>
      <NdsMenuItem
        v-if="store.getters.lang === 'en'"
        data-testid="btn-switch-french"
        :is-checkable="false"
        @input="setShareLang('fr')"
      >
        <template #label>
          <div class="languageSelectorDropdown__item">
            <flag iso="fr" />
            <span>Français</span>
          </div>
        </template>
      </NdsMenuItem>

      <NdsMenuItem
        v-if="store.getters.lang === 'fr'"
        data-testid="btn-switch-english"
        :is-checkable="false"
        @input="setShareLang('en')"
      >
        <template #label>
          <div class="languageSelectorDropdown__item">
            <flag iso="gb" />
            <span>English</span>
          </div>
        </template>
      </NdsMenuItem>
    </template>
  </NdsDropdown>
</template>

<script setup lang="ts">
import Vue, { onMounted } from 'vue'
import NdsButton from '@/components/NewDesignSystem/NdsButton/NdsButton.vue'
import NdsDropdown from '@/components/NewDesignSystem/NdsDropdown/NdsDropdown.vue'
import NdsMenuItem from '@/components/NewDesignSystem/NdsMenuItem/NdsMenuItem.vue'
import { NdsButtonColor, NdsButtonSize } from '@/components/NewDesignSystem/NdsButton/NdsButton.interfaces'
import { rootBus } from '@/contexts/shared/event-bus/RootBus'
import { useStore } from '@/store'
import { NdsPopoverPlacement } from '@/components/NewDesignSystem/NdsPopover/NdsPopover.interfaces'

const $moment = Vue.prototype.$moment
const store = useStore()

const setShareLang = (lang: string) => {
  store.commit('set_lang', lang)
  rootBus.emit('shareLangChange')
  if (lang === 'fr') {
    $moment.locale('fr_FR')
  } else if (lang === 'en') {
    $moment.locale('en_US')
  } else {
    $moment.locale('fr_FR')
  }
}

onMounted(() => {
  setShareLang('fr')
})
</script>

<style lang="scss" scoped>
.languageSelectorDropdown {
  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}
</style>
